import { configFetch as fetch } from '@laigu/utils';

// 获取个人设置
export const getPersonalConfigApi = () => {
  return fetch({
    url: '/agent/personal_config',
    method: 'get'
  });
};

export const updatePersonalConfigApi = ({ data }) => {
  return fetch({
    url: '/agent/personal_config',
    method: 'post',
    data
  });
};
